import { createResource } from 'react-resource-router';

import { captureExceptionWithTags } from 'src/utils/sentry';

import { getImmutableTagSettings } from '../requests';
import { ImmutableTagSettings } from '../types';

export const immutableTagSettingsResource =
  createResource<ImmutableTagSettings>({
    type: 'immutable-tag-settings',
    getKey: ({ match: { params } }) =>
      `${params.workspaceSlug}/immutable-tag-settings`,
    maxAge: 0, // always fetch fresh — settings should not be stale
    getData: async ({ match: { params } }) => {
      const { workspaceSlug } = params;

      if (!workspaceSlug) {
        throw new Error(
          'This resource must be rendered on a valid route with a workspace slug'
        );
      }

      try {
        return await getImmutableTagSettings(workspaceSlug);
      } catch (error: unknown) {
        if (error instanceof Error) {
          captureExceptionWithTags(error);
        }

        throw error;
      }
    },
  });
